import React from 'react';
import styles from './Splash.module.css';

const Splash = () => {
    return (
        <div className={styles.container}>
            <div className={styles.bootstrapSplashRubix}>
                <div className={styles.bootstrapSplashTop}></div>
                <div className={styles.bootstrapSplashBottom}></div>
                <div className={styles.bootstrapSplashLeft}></div>
                <div className={styles.bootstrapSplashRight}></div>
            </div>
        </div>
    );
};

export default Splash;
